module.exports = __webpack_public_path__ + "img/time.8029eb3.webp";